var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10BAFC"
    },
    d: "M336.458,84.624H175.542c-13.271,0-24.024,10.728-24.024,23.966v115.268 c0,13.239,10.753,23.979,24.024,23.979h49.797l30.653,53.116l30.67-53.116h49.797c13.276,0,24.04-10.741,24.04-23.979V108.59 C360.498,95.352,349.735,84.624,336.458,84.624z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.706,
    y: 327.064,
    style: {
      fill: "#FFFFFF"
    },
    width: 124.688,
    height: 58.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.651,
    y: 327.064,
    style: {
      fill: "#FF1A1A"
    },
    width: 124.688,
    height: 58.167
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 347.606,
    y: 327.064,
    style: {
      fill: "#FFFFFF"
    },
    width: 124.688,
    height: 58.167
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "234.276,196.858 287.451,166.241 234.276,135.606  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.294,
    y: 327.064,
    style: {
      fill: "#D6E3E9"
    },
    width: 29.257,
    height: 100.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.449,
    y: 327.064,
    style: {
      fill: "#D6E3E9"
    },
    width: 29.257,
    height: 100.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.394,
    y: 327.064,
    style: {
      fill: "#D6E3E9"
    },
    width: 29.257,
    height: 100.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.349,
    y: 327.064,
    style: {
      fill: "#D6E3E9"
    },
    width: 29.257,
    height: 100.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.542,258.286h43.762l27.638,47.89c1.866,3.234,5.315,5.227,9.049,5.227l0,0c3.733,0,7.183-1.992,9.05-5.224 l27.653-47.892h43.765c19.017,0,34.489-15.445,34.489-34.428V108.59c0-18.976-15.472-34.415-34.489-34.415H175.542 c-19.009,0-34.473,15.437-34.473,34.415v115.268C141.069,242.842,156.533,258.286,175.542,258.286z M161.966,108.59 c0-7.453,6.09-13.517,13.575-13.517h160.916c7.494,0,13.591,6.064,13.591,13.517v115.268c0,7.462-6.097,13.53-13.591,13.53h-49.797 c-3.732,0-7.183,1.992-9.049,5.224l-21.618,37.44l-21.605-37.438c-1.866-3.235-5.316-5.227-9.05-5.227h-49.797 c-7.486,0-13.575-6.07-13.575-13.53V108.59H161.966z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.046,205.904c1.618,0.936,3.423,1.403,5.23,1.403c1.799,0,3.6-0.464,5.214-1.394l53.176-30.618 c3.239-1.864,5.235-5.316,5.235-9.054c0-3.737-1.995-7.19-5.233-9.055l-53.176-30.634c-3.233-1.861-7.214-1.86-10.445,0.007 c-3.231,1.867-5.22,5.315-5.22,9.047v61.252C223.827,200.589,225.816,204.037,229.046,205.904z M244.725,153.685l21.79,12.553 l-21.79,12.547V153.685z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M501.551,316.617h-29.257H347.603h-29.257l0,0l0,0H193.654l0,0l0,0h-29.257H39.706H10.449 C4.678,316.617,0,321.296,0,327.066v100.31c0,5.77,4.678,10.449,10.449,10.449h29.257c5.771,0,10.449-4.679,10.449-10.449v-31.694 h103.793v31.694c0,5.77,4.678,10.449,10.449,10.449h29.257c5.771,0,10.449-4.679,10.449-10.449v-31.694h103.794v31.694 c0,5.77,4.678,10.449,10.449,10.449h29.257c5.771,0,10.449-4.679,10.449-10.449v-31.694h103.793v31.694 c0,5.77,4.678,10.449,10.449,10.449h29.257c5.771,0,10.449-4.679,10.449-10.449v-100.31 C512,321.295,507.322,316.617,501.551,316.617z M29.257,416.927h-8.359v-79.412h8.359v47.718V416.927z M50.155,374.784v-37.269 h103.793v37.269H50.155z M183.205,416.927h-8.359v-31.694v-47.718h8.359V416.927z M307.897,374.784H204.104v-37.269h103.793V374.784 z M337.154,416.927h-8.359v-79.412h8.359v47.718V416.927z M358.052,374.784v-37.269h103.793v37.269H358.052z M491.102,416.927 h-8.359v-31.694v-47.718h8.359V416.927z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.599,226.079c5.771,0,10.449-4.679,10.449-10.449v-56.281c0-5.771-4.678-10.449-10.449-10.449 s-10.449,4.679-10.449,10.449v56.281C174.15,221.402,178.829,226.079,184.599,226.079z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.599,138.308c5.771,0,10.449-4.679,10.449-10.449v-17.118c0-5.77-4.678-10.449-10.449-10.449 s-10.449,4.679-10.449,10.449v17.118C174.15,133.63,178.828,138.308,184.599,138.308z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditing);
export default __webpack_public_path__ + "static/media/editing.73f62f01a2eb46cc6fa4d5bd4f26c592.svg";
export { ForwardRef as ReactComponent };